/**
 * 表单初始化数据
 * @param form
 * @param data
 * @returns {*}
 */
export function initObject(form, data) {
    if (typeof form !== 'object') {
        form = {}
    }
    if (Array.isArray(data)) {
        return data.slice()
    }
    Object.keys(form).forEach(property => {
        // if (data.hasOwnProperty(property)) {
        if (Object.prototype.hasOwnProperty.call(data, property)) {
            form[property] = data[property]
        }
    })
    return form
}

/**
 * 首页导航二级归类
 * @param data
 * @returns {{}}
 */
export function handleNavData(data=[],sort='sort'){
    let temp= {}
   data.map((v)=>{
        temp[v.id] = v
    })
    for (let t in temp) {
        if(temp[t].parent_id){
            if(!Array.isArray(temp[temp[t].parent_id]['children'])){
                temp[temp[t].parent_id]['children'] = []
            }
            temp[temp[t].parent_id]['children'].push(temp[t])
            temp[temp[t].parent_id]['children'].sort((a, b)=> { return a[sort] - b[sort] })
            delete temp[t]
        }
    }
    temp = Object.values(temp)
    temp.sort( (a, b)=> { return a[sort] - b[sort] })
    return temp
}

/**
 * 格式化时间
 * @param type
 * @param time
 * @returns {string|number}
 */
export function getFormatDate(type = 'day',time='') {
    let result
    const myDate = time?new Date(time):new Date()
    const year = myDate.getFullYear()
    const month = ((myDate.getMonth() + 1) < 10 ? '0' : '') + (myDate.getMonth() + 1)
    const day = myDate.getDate()
    result = year + '-' + month
    if (type === 'day') {
        result = result + '-' + day
    }
    if (type === 'month') {
        result = year + '-' + month
    }
    if (type === 'singleYear') {
        result = year
    }
    if (type === 'singleMonth') {
        result = month
    }
    if (type === 'singleDay') {
        result = day
    }
    return result
}

/**
 * 格式化字符串
 * @param str
 * @param len
 * @returns {string}
 */
export function getFormatStr(str='',len=20){
    return str.slice(0,len)+'...'
}

export function imgSrc(content=''){
    let result= content
    const imgReg = /<img.*?(?:>|\/>)/gi
    const srcReg = /src=['"]?([^'"]*)['"]?/i
    const arr = content.match(imgReg)
    const base_url = process.env.VUE_APP_BASE_API
    for (let i = 0; i < arr.length; i++) {
        let src = arr[i].match(srcReg)
        console.log('src',src)
        //获取图片地址
        if(src[1]){
            //alert('已匹配的图片地址'+(i+1)+'：'+src[1])
            console.log('src',src[1])
            result=  result.replace(src[1],base_url+src[1])
        }
        //当然你也可以替换src属性
        // if (src[0]) {
        //     let t = src[0].replace(/src/i, "src")
        //     console.log('t',t)
        // }
    }
    return result
}

